<div class="no-field-space" [formGroup]="formGroup">
  <sc-flex [gap]="8">
    <sc-date-field formControlName="dateFrom"
      [label]="'' | translate:['tmc-yard.control.entity.transport-option-limits-schedule.dateFrom', translationService.language]"></sc-date-field>
    <sc-date-field formControlName="dateUntil"
      [label]="'' | translate:['tmc-yard.control.entity.transport-option-limits-schedule.dateUntil', translationService.language]"></sc-date-field>
    <sc-content-spacer grow></sc-content-spacer>
    <sc-action-icon iconClass="fa-trash-circle fa-2x" (click)="removeLimitSchedule()"></sc-action-icon>
  </sc-flex>
  <sc-content-spacer half vertical stretchContent></sc-content-spacer>
  <sc-flex [gap]="8">
    <sc-number-field class="dayField" formControlName="limitMonday"
      labelDictionaryKey="tmc-yard.control.entity.transport-option-limits-schedule.limitMonday"></sc-number-field>
    <sc-number-field class="dayField" formControlName="limitTuesday"
      labelDictionaryKey="tmc-yard.control.entity.transport-option-limits-schedule.limitTuesday"></sc-number-field>
    <sc-number-field class="dayField" formControlName="limitWednesday"
      labelDictionaryKey="tmc-yard.control.entity.transport-option-limits-schedule.limitWednesday"></sc-number-field>
    <sc-number-field class="dayField" formControlName="limitThursday"
      labelDictionaryKey="tmc-yard.control.entity.transport-option-limits-schedule.limitThursday"></sc-number-field>
    <sc-number-field class="dayField" formControlName="limitFriday"
      labelDictionaryKey="tmc-yard.control.entity.transport-option-limits-schedule.limitFriday"></sc-number-field>
    <sc-number-field class="dayField" formControlName="limitSaturday"
      labelDictionaryKey="tmc-yard.control.entity.transport-option-limits-schedule.limitSaturday"></sc-number-field>
    <sc-number-field class="dayField" formControlName="limitSunday"
      labelDictionaryKey="tmc-yard.control.entity.transport-option-limits-schedule.limitSunday"></sc-number-field>
  </sc-flex>
  <sc-content-spacer double vertical></sc-content-spacer>
  <sc-flex>
    <sc-content-spacer double></sc-content-spacer>
    <sc-flex-fitting-content>
      <sc-sub-title><sc-dictionary-label
          dictionaryKey="tmc-yard.control.ui.transport-option-administration.limit-exceptions"></sc-dictionary-label></sc-sub-title>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-flex vertical [gap]="16" stretchContent>
        <app-transport-option-editor-limits-exception-schedule
          *ngFor="let exceptionSchedule of schedule.limitExceptionSchedules"
          [exceptionSchedule]="exceptionSchedule" (removeRequested)="removeExceptionSchedule($event)"></app-transport-option-editor-limits-exception-schedule>
        <sc-flex centered>
          <sc-action-icon iconClass="fa-plus-circle fa-2x" (click)="addLimitExceptionSchedule()"></sc-action-icon>
          <sc-content-spacer></sc-content-spacer>
          <sc-dictionary-label
            dictionaryKey="tmc-yard.control.ui.transport-option-administration.add-limit-exception-schedule"></sc-dictionary-label>
        </sc-flex>
      </sc-flex>
    </sc-flex-fitting-content>
  </sc-flex>
</div>
